var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 449.33 408.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 71.41,
    y1: 220.61,
    x2: 337.87,
    y2: 220.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126ba8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2692d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 283.55,
    y1: 216.71,
    x2: 449.33,
    y2: 216.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#69b5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12abdf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 181.22,
    x2: 355.57,
    y2: 181.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 35.25,
    y1: 253.04,
    x2: 351.03,
    y2: 253.04,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.35 325.85 131.96 175.6 165.3 325.85 193.47 325.85 269.46 175.6 249.36 325.85 303.39 325.85 337.87 107.87 266.44 107.87 186.81 269.13 153.62 107.87 98.41 107.87 71.41 281.52 99.61 333.36 108.35 325.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M449.02,163.44s5.39-35-29.29-48.8c0,0-23.65-7.97-44.03-6.77h-63l-29.15,217.82,48.02-.95s42.19,5.14,74.12-8.56c0,0,29.72-8.23,37.37-47.5,0,0,15.83-45.56-32.6-57.69,0,0,31.07-4.07,38.57-47.54Zm-52.02,109.82c-7.69,20.67-40.16,18.26-40.16,18.26h-36.63l8.02-63.29h38.21c10.03,.97,25.58,5,25.58,5,17.43,18,4.98,40.04,4.98,40.04Zm-.05-88.22c-5.33,19.39-63.75,14.53-63.75,14.53l10.02-59.18h25.48c29.78,1.96,32.59,12.03,32.59,12.03,8.51,18.25-4.35,32.62-4.35,32.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.95,228.57C26.95,116.46,117.83,25.58,229.94,25.58c47.44,0,91.08,16.28,125.64,43.55C318.37,26.75,263.81,0,202.99,0,90.88,0,0,90.88,0,202.99c0,64.67,30.24,122.27,77.35,159.44-31.38-35.73-50.41-82.57-50.41-133.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M233.89,385.21c-97.88-.58-176.75-80.4-176.17-178.28,.25-41.42,14.69-79.43,38.67-109.46-37.19,32.26-60.83,79.76-61.14,132.86-.58,97.88,78.29,177.7,176.17,178.28,56.46,.34,106.91-25.77,139.61-66.71-31.36,27.21-72.36,43.58-117.14,43.31Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMb);
export default __webpack_public_path__ + "static/media/MB.90e9a73d0bfa5a8b50a7bae0229c29e2.svg";
export { ForwardRef as ReactComponent };